import { initialCategory } from "./requestContext";
export { readRequestDraft } from "./requestContext";
// Reuse the acquisition allowlist; never infer intent from arbitrary UTM substrings.
const CATEGORY_ALIASES = { "it-teknologi": "it-net", it: "it-net" };
const CAMPAIGN_CATEGORIES = { it: "it-teknologi" };

// Carry existing entry context through a deliberate CTA without adding tracking storage.
export function requestEntryUrl(search = "", context = {}) {
  const source = new URLSearchParams(search);
  const params = new URLSearchParams();
  for (const key of ["category", "kategori", "service", "seo_landing", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"]) {
    if (source.get(key)) params.set(key, source.get(key));
  }
  for (const [key, value] of Object.entries(context)) if (value) params.set(key, value);
  const query = params.toString();
  return `/beskriv-problem${query ? `?${query}` : ""}`;
}

export function categoryByKey(categories, key) {
  if (!key) return null;
  const published = categories.filter((c) => c.active !== false);
  return published.find((c) => c.id === key || c.slug === key)
    || published.find((c) => c.slug === CATEGORY_ALIASES[key]) || null;
}

export function resolveRequestEntry({ params, categories, landing, expert }) {
  const explicitKey = params.get("category") ?? params.get("kategori");
  const explicit = categoryByKey(categories, explicitKey);
  const service = categoryByKey(categories, landing?.category_id);
  const provider = categoryByKey(categories, expert?.category_ids?.[0] || expert?.category_id);
  const campaign = params.get("utm_campaign");
  const campaignCategory = categoryByKey(categories, CAMPAIGN_CATEGORIES[campaign]);
  const campaignParams = new URLSearchParams(params);
  campaignParams.delete("seo_landing"); // Service intent must come from the published SEO response.
  const acquisitionCategory = categoryByKey(categories, initialCategory(categories, campaignParams.toString()));
  // An explicit unknown/empty category must not be rescued by campaign or SEO guesses.
  const category = explicitKey !== null ? explicit : service || provider || campaignCategory || acquisitionCategory;
  const matchingLanding = category && service?.id === category.id ? landing : null;
  const isCampaign = Boolean(params.get("utm_campaign") || params.get("gclid"));
  return {
    categoryId: category?.id || "",
    entry_type: expert ? "provider_profile" : explicit ? "category_link" : explicitKey !== null ? "generic" : isCampaign ? "campaign" : matchingLanding ? "seo_service" : "generic",
    category_preselected: Boolean(category),
    category: category?.slug || null,
    service_context: matchingLanding?.page_type === "service" ? matchingLanding.slug : null,
    seoLandingSlug: matchingLanding?.slug || null,
  };
}

export const LANGUAGES = { da: "Dansk", en: "English", sv: "Svenska", de: "Deutsch" };
export const TIMINGS = { now: "Hurtigst muligt", today: "I dag", flex: "Fleksibelt" };
